import { useMutation } from 'react-query';

import {
  logCritical,
  logError,
} from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';

import { PaymentService } from '@/api';

export const useConfirmPaymentIntent = ({
  onSuccess,
  invoiceId,
  claimGroupId,
  fileId,
}: {
  invoiceId: string;
  onSuccess?: () => Promise<void>;
  claimGroupId?: string;
  fileId?: string;
}) => {
  const { pushErrors } = useToasts();

  const { mutateAsync } = useMutation(
    'handleConfirmPaymentIntent',
    async (payload: { metadata?: { sessionResult: string } }) => {
      const response = await PaymentService.confirmPaymentIntent({
        invoiceId,
        metadata: payload?.metadata ?? undefined,
      });

      if (response.failure) {
        logError(response.errors[0].message);

        throw new Error(response.errors[0].message);
      }

      if (onSuccess) {
        await onSuccess();
      }

      return response;
    },
    {
      retry: 5,
      retryDelay: 2_500,
      onError: (error: any) => {
        pushErrors(error.message);

        logCritical(
          `InvoicePaymentForm.handleSubmit: invoiceId => ${invoiceId}, claimGroupId => ${claimGroupId}, fileId => ${fileId}`,
          {
            invoiceId,
            error,
            claimGroupId,
            fileId,
            errorMessage: error.message,
          },
        );
      },
    },
  );

  return { handleConfirmPaymentIntent: mutateAsync };
};
